export default __webpack_public_path__ + "assets/images/72b701026efefc471ac4fe1a0ccb96fd.svg";